/* eslint-disable implicit-arrow-linebreak */
// httpUtils.ts

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

interface RequestOptions {
  params?: Record<string, unknown>;
}

const BASE_URL = 'https://exuberant-delight-b9cd8a8a13.strapiapp.com/api'; // Replace with your actual API base
const BEARER_TOKEN = process.env.REACT_APP_STRAPI_KEY || '';

async function request(
  method: HttpMethod,
  endpoint: string,
  options?: RequestOptions,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> {
  const url = new URL(`${BASE_URL}${endpoint}`);
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${BEARER_TOKEN}`,
  };

  const fetchOptions: RequestInit = {
    method,
    headers,
  };

  if (method === 'GET' && options?.params) {
    Object.entries(options.params).forEach(
      ([key, value]) => url.searchParams.append(key, String(value)),
      // eslint-disable-next-line function-paren-newline
    );
  } else if (options?.params) {
    fetchOptions.body = JSON.stringify(options.params);
  }

  const response = await fetch(url.toString(), fetchOptions);

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`HTTP ${response.status}: ${errorText}`);
  }

  return response.json();
}

export default {
  get: (endpoint: string, options?: RequestOptions) =>
    request('GET', endpoint, options),
  post: (endpoint: string, options?: RequestOptions) =>
    request('POST', endpoint, options),
  put: (endpoint: string, options?: RequestOptions) =>
    request('PUT', endpoint, options),
  delete: (endpoint: string, options?: RequestOptions) =>
    request('DELETE', endpoint, options),
};
